const light = {
  name: "light",
  colors: {
    bodyBackground: "#f6f7fb",
    bodyPattern:
      "radial-gradient(circle, rgba(245, 158, 11, 0.08) 1px, transparent 1px)",
    text: "#646363",
    secondaryText: "#374151",
    tertiaryText: "#6b7280",
    mutedText: "#9ca3af",
    hoveredLinkText: "#ffffff",
    border: "#e5e7eb",
    activatedBorder: "#f59e0b",
    background: "#f3f4f6",
    surface: "#ffffff",
    surfaceMuted: "#fffbeb",
    surfaceElevated: "#fff7ed",
    icon: "#6b7280",
    divider: "#e5e7eb",
    headerBackground: "rgba(255, 255, 255, 0.82)",
    headerShadow: "rgba(15, 23, 42, 0.08)",
    inlineCodeBackground: "#f9d853",
    inlineCodeBackgroundDarker: "#fde68a",
    tagBackground: "#fff7ed",
    selectedTagBackground: "#f59e0b",
    hoveredTagBackground: "#ffedd5",
    hoveredSelectedTagBackground: "#d97706",
    nextPostButtonBackground: "#fff7ed",
    hoveredNextPostButtonBackground: "#ffedd5",
    seriesBackground: "#fffbeb",
    tagText: "#7c2d12",
    selectedTagText: "#ffffff",
    spinner: "#d97706",
    scrollTrack: "#f3f4f6",
    scrollHandle: "#d1d5db",
    blockQuoteBorder: "#f59e0b",
    blockQuoteBackground: "#fffbeb",
    textFieldBorder: "#d1d5db",
    textFieldActivatedBorder: "#f59e0b",
    tableBackground: "#fffbeb",
    accent: "#f59e0b",
    accentHover: "#d97706",
    accentSubtle: "#fff7ed",
    accentText: "#7c2d12",
    focusRing: "rgba(245, 158, 11, 0.42)",
  },
}

const dark = {
  name: "dark",
  colors: {
    bodyBackground: "#060b16",
    bodyPattern:
      "radial-gradient(circle, rgba(251, 191, 36, 0.16) 1px, transparent 1px)",
    text: "#f8fafc",
    secondaryText: "#cbd5e1",
    tertiaryText: "#94a3b8",
    mutedText: "#64748b",
    hoveredLinkText: "#111827",
    border: "#30425b",
    activatedBorder: "#f59e0b",
    background: "#0f1627",
    surface: "#172338",
    surfaceMuted: "#1d2c45",
    surfaceElevated: "#22324d",
    icon: "#94a3b8",
    divider: "#28374f",
    headerBackground: "rgba(6, 11, 22, 0.82)",
    headerShadow: "rgba(0, 0, 0, 0.45)",
    inlineCodeBackground: "#1f2937",
    inlineCodeBackgroundDarker: "#111827",
    tagBackground: "#22324d",
    selectedTagBackground: "#f59e0b",
    hoveredTagBackground: "#263349",
    hoveredSelectedTagBackground: "#fbbf24",
    nextPostButtonBackground: "#1d2c45",
    hoveredNextPostButtonBackground: "#283a58",
    seriesBackground: "#1d2c45",
    tagText: "#e2e8f0",
    selectedTagText: "#111827",
    spinner: "#f59e0b",
    scrollTrack: "#0f1627",
    scrollHandle: "#42597a",
    blockQuoteBorder: "#f59e0b",
    blockQuoteBackground: "#384459",
    textFieldBorder: "#334155",
    textFieldActivatedBorder: "#f59e0b",
    tableBackground: "#141f33",
    accent: "#f59e0b",
    accentHover: "#fbbf24",
    accentSubtle: "#243652",
    accentText: "#fef3c7",
    focusRing: "rgba(251, 191, 36, 0.35)",
  },
}

export { light, dark }
